<template>
    <portal :to="portalTo">
        <transition
            enter-active-class="transition-opacity ease-linear duration-150"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity ease-linear duration-150"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed z-20 inset-0 overflow-y-auto" v-if="isOpen">
                <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" @click="close">
                        <div class="absolute inset-0 bg-gray-500 opacity-75" />
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                    <div
                        aria-labelledby="modal-headline"
                        aria-modal="true"
                        class="w-full inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:p-6"
                        role="dialog"
                    >
                        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                            <button
                                aria-label="Close"
                                class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                                type="button"
                                @click="close"
                            >
                                <svg
                                    class="h-6 w-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        d="M6 18L18 6M6 6l12 12"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div>
                            <slot />
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: false,
                required: true,
            },
            portalTo: {
                type: String,
                default: 'modal',
            },
        },

        watch: {
            isOpen(newValue) {
                if (newValue) {
                    this.$emit('onOpen');
                } else {
                    this.$emit('onClose');
                }
            },
        },

        methods: {
            close() {
                this.$parent.$emit('update:isOpen', false);
            },
        },
    };
</script>
